/**
 * Canonical TAi-P persona configuration.
 *
 * Internal keys are deliberately stable because they are shared with saved
 * trips, analytics and the backend. User-facing labels live here so every
 * surface uses the same English and Bahasa Melayu terminology.
 */
export const PERSONAS = Object.freeze([
  { key: "family", emoji: "👨‍👩‍👧", i18n: "persona.family" },
  { key: "honeymoon", emoji: "💖", i18n: "persona.honeymoon" },
  { key: "riders", emoji: "🏍", i18n: "persona.riders" },
  { key: "food", emoji: "🍜", i18n: "persona.food" },
  { key: "shopping", emoji: "🛍", i18n: "persona.shopping" },
  { key: "beach", emoji: "🏖", i18n: "persona.beach" },
  { key: "nature", emoji: "🌿", i18n: "persona.nature" },
  { key: "themepark", emoji: "🎢", i18n: "persona.themepark" },
]);

export const PERSONA_LABELS = Object.freeze({
  en: Object.freeze({
    family: "Family",
    honeymoon: "Honeymoon",
    riders: "Touring",
    food: "Food",
    shopping: "Shopping",
    beach: "Beach",
    nature: "Nature",
    themepark: "Theme Park",
  }),
  ms: Object.freeze({
    family: "Keluarga",
    honeymoon: "Bulan Madu",
    riders: "Kembara",
    food: "Makanan",
    shopping: "Membeli-belah",
    beach: "Pantai",
    nature: "Alam Semula Jadi",
    themepark: "Taman Tema",
  }),
});

export const PERSONA_TRANSLATIONS = Object.freeze(
  Object.fromEntries(
    Object.entries(PERSONA_LABELS).map(([lang, labels]) => [
      lang,
      Object.freeze(
        Object.fromEntries(PERSONAS.map(({ key, i18n }) => [i18n, labels[key]]))
      ),
    ])
  )
);

export function getPersonaLabel(key, lang = "ms") {
  const labels = PERSONA_LABELS[lang] || PERSONA_LABELS.ms;
  return labels[key] || key;
}

